import type { IBaseCampaignVersion } from '~/modules/campaign';

import { convertToDateTimeFilters, useDateTimePickerContext } from '~/presentation/ui';
import { useCampaignMaps } from '~/modules/campaign-template';

export const useApplyCampaignDate = () => {
  const { campaignMap, campaignGroupMap } = useCampaignMaps();
  const { setDateTimePicked, dateTimePicked } = useDateTimePickerContext();

  const setDateByCampaignId = (campaignId: string) => {
    if (!dateTimePicked.isVersion) return;

    const campaign = campaignMap[campaignId] || campaignGroupMap[campaignId];
    if (!campaign?.versions) return;

    const versions = convertToDateTimeFilters(campaign.versions as IBaseCampaignVersion[]);
    const date = versions[0];
    if (!date) return;

    setDateTimePicked(date);
  };
  return {
    setDateByCampaignId,
  };
};
